import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _160a7516 = () => interopDefault(import('../app/pages/apple/index.vue' /* webpackChunkName: "pages/apple/index" */))
const _4dff3978 = () => interopDefault(import('../app/pages/authorize/index.vue' /* webpackChunkName: "pages/authorize/index" */))
const _d0431a86 = () => interopDefault(import('../app/pages/eula.vue' /* webpackChunkName: "pages/eula" */))
const _3947623e = () => interopDefault(import('../app/pages/facebook/index.vue' /* webpackChunkName: "pages/facebook/index" */))
const _b6dd00bc = () => interopDefault(import('../app/pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _ac91986a = () => interopDefault(import('../app/pages/playpl/index.vue' /* webpackChunkName: "pages/playpl/index" */))
const _2ba11832 = () => interopDefault(import('../app/pages/reset.vue' /* webpackChunkName: "pages/reset" */))
const _8a22570a = () => interopDefault(import('../app/pages/resetpass/index.vue' /* webpackChunkName: "pages/resetpass/index" */))
const _3d8b3c9b = () => interopDefault(import('../app/pages/success.vue' /* webpackChunkName: "pages/success" */))
const _3bc27d64 = () => interopDefault(import('../app/pages/twitter/index.vue' /* webpackChunkName: "pages/twitter/index" */))
const _9917281c = () => interopDefault(import('../app/pages/debug/session.vue' /* webpackChunkName: "pages/debug/session" */))
const _a40d8b9e = () => interopDefault(import('../app/pages/facebook/return.vue' /* webpackChunkName: "pages/facebook/return" */))
const _9a0a1af2 = () => interopDefault(import('../app/pages/playpl/return.vue' /* webpackChunkName: "pages/playpl/return" */))
const _f0f5d538 = () => interopDefault(import('../app/pages/twitter/return.vue' /* webpackChunkName: "pages/twitter/return" */))
const _056fc288 = () => interopDefault(import('../app/pages/v1/health.vue' /* webpackChunkName: "pages/v1/health" */))
const _326cf767 = () => interopDefault(import('../app/pages/facebook/token/_facebookAccessToken.vue' /* webpackChunkName: "pages/facebook/token/_facebookAccessToken" */))
const _96c90bf2 = () => interopDefault(import('../app/pages/twitter/token/_twitterAccessToken.vue' /* webpackChunkName: "pages/twitter/token/_twitterAccessToken" */))
const _5b00137e = () => interopDefault(import('../app/pages/authorize/_social.vue' /* webpackChunkName: "pages/authorize/_social" */))
const _73e522f9 = () => interopDefault(import('../app/pages/resetpass/_sessionId.vue' /* webpackChunkName: "pages/resetpass/_sessionId" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/apple",
    component: _160a7516,
    name: "apple"
  }, {
    path: "/authorize",
    component: _4dff3978,
    name: "authorize"
  }, {
    path: "/eula",
    component: _d0431a86,
    name: "eula"
  }, {
    path: "/facebook",
    component: _3947623e,
    name: "facebook"
  }, {
    path: "/logout",
    component: _b6dd00bc,
    name: "logout"
  }, {
    path: "/playpl",
    component: _ac91986a,
    name: "playpl"
  }, {
    path: "/reset",
    component: _2ba11832,
    name: "reset"
  }, {
    path: "/resetpass",
    component: _8a22570a,
    name: "resetpass"
  }, {
    path: "/success",
    component: _3d8b3c9b,
    name: "success"
  }, {
    path: "/twitter",
    component: _3bc27d64,
    name: "twitter"
  }, {
    path: "/debug/session",
    component: _9917281c,
    name: "debug-session"
  }, {
    path: "/facebook/return",
    component: _a40d8b9e,
    name: "facebook-return"
  }, {
    path: "/playpl/return",
    component: _9a0a1af2,
    name: "playpl-return"
  }, {
    path: "/twitter/return",
    component: _f0f5d538,
    name: "twitter-return"
  }, {
    path: "/v1/health",
    component: _056fc288,
    name: "v1-health"
  }, {
    path: "/facebook/token/:facebookAccessToken?",
    component: _326cf767,
    name: "facebook-token-facebookAccessToken"
  }, {
    path: "/twitter/token/:twitterAccessToken?",
    component: _96c90bf2,
    name: "twitter-token-twitterAccessToken"
  }, {
    path: "/authorize/:social",
    component: _5b00137e,
    name: "authorize-social"
  }, {
    path: "/resetpass/:sessionId",
    component: _73e522f9,
    name: "resetpass-sessionId"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
